export default __webpack_public_path__ + "static/gaku-screen-2-4afde816058a21a94fe644a7e4f8ee22.png";